<template>

    <user-time-registration
        :timeregistration-uri="route('api.v1.hr.users.timeregistration.user', {id:getHrUser.uuid})"
        :costcodes-uri="route('api.v1.costcodes.index')"
    ></user-time-registration>

</template>

<script>

import {mapGetters} from "vuex";
import UserTimeRegistration from "../../../components/HR/Timeregistration/UserTimeRegistration";

export default {

    components: {
        UserTimeRegistration,
    },

    computed: {
        ...mapGetters([
            'getHrUser',
        ]),
    },

    metaInfo: {
        title:'Urenregistratie bekijken',
    },

    name:'HrUsersTimeregistration',

}

</script>
